<ac-input-container label="Select Log Level">
    <ac-single-select [(acModel)]="logLevel.value"
                      [items]="logDebugLevelItems"
                      bindValue="name"
                      bindLabel="viewName">
    </ac-single-select>
</ac-input-container>


